import React, { forwardRef } from 'react';
import { Box } from '@mui/material';
import { InputMask, InputMaskProps } from '@react-input/mask';

import { LocalizationTypography } from '~components/organisms';

export const PhoneInputMask = forwardRef<
  HTMLInputElement,
  InputMaskProps & { hasValue: boolean; hasError: boolean }
>((props, forwardedRef) => {
  const { hasValue, hasError, ...rest } = props;

  return (
    <Box
      width="100%"
      height="100%"
      position="relative"
      sx={(theme) => ({
        overflow: 'hidden',
        input: {
          ...theme.typography['Inter/Body-md'],
          boxSizing: 'border-box',
          padding: '24px 12px 8px',
          height: '100%',
          width: '100%',
        },
        '#phoneNumberInnerLabel': {
          position: 'absolute',
          left: 0,
          top: 0,
          transform: hasValue
            ? 'translate(12px, 7px) scale(0.75)'
            : 'translate(12px, 16px) scale(1)',
          transformOrigin: 'top left',
          color: hasError
            ? theme.palette.error.main
            : theme.palette.text.secondary,
          transition:
            'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
        },
        'input:focus + #phoneNumberInnerLabel, #hasValue + #phoneNumberInnerLabel':
          {
            transform: 'translate(12px, 7px) scale(0.75)',
            color: hasError
              ? theme.palette.error.main
              : theme.palette.primary.main,
          },
      })}
      component="label"
    >
      <InputMask ref={forwardedRef} replacement={{ '.': /\d/ }} {...rest} />
      <Box id="phoneNumberInnerLabel" component="span">
        <LocalizationTypography
          noWrap
          textId="app.rentalPage.stepOne.phoneNumber"
          defaultText="Phone Number"
          variant="Inter/Body-sm"
        />
      </Box>
    </Box>
  );
});
